module.exports = __webpack_public_path__ + "img/footer_pic_cbs@2x.cf9eb508.png";